import React from "react";
import infoImg from "../../assets/images/info.svg";
import notificationImg from "../../assets/images/notification.svg";
import profileImg from "../../assets/images/profile.svg";

function PlayerSigned() {
  return (
    <div className="main-sec">
      <div className="bgBlue p-relative h-100 p-3">
        <div className="justify-between">
          <img src={infoImg} alt="info" />
          <div className="d-flex">
            <img className="" src={notificationImg} alt="notification" />
            <img src={profileImg} alt="profile" />
          </div>
        </div>
      </div>
    </div>
  );
}
export default PlayerSigned;
